import React, { useState } from "react";

const Education = () => {
  const [activeTab, setActiveTab] = useState("academic");
  return (
    <div className="education__container section">
      <h2 className="section__title"> Qualification </h2>
      <span className="section__subtitle">Relevant Experience/Background</span>

      <div className="qualification__container container">
        <div className="qualification__tabs">
          <div
            className={`qualification__button button--flex ${
              activeTab === "academic" ? "qualification__active" : ""
            }`}
            onClick={() => setActiveTab("academic")}
          >
            <i className="uil uil-graduation-cap qualification__icon"></i>
            <span>Academic Background</span>
          </div>
          <div
            className={`qualification__button button--flex ${
              activeTab === "work" ? "qualification__active" : ""
            }`}
            onClick={() => setActiveTab("work")}
          >
            <i className="uil uil-briefcase-alt qualification__icon"></i>
            <span>Work Experience</span>
          </div>
        </div>

        <div className="qualification__sections">
          {activeTab === "academic" && (
            <div className="qualification__content qualification__content-active">
              <div className="qualification__data">
                <div>
                  <h3 className="qualification__title"> Spring Semester</h3>
                  <span className="qualification__subtitle">
                    San Francisco State University{" "}
                  </span>
                  <div className="qualification__courses">
                    <ul className="qualification__course__list">
                      <li className="qualification__course__item">
                        <h5>(CSC 648) Software Engineering</h5>
                      </li>
                      <li className="qualification__course__item">
                        <h5>
                          (CSC 667)Internet Application Design & Development
                        </h5>
                      </li>
                      <li className="qualification__course__item">
                        <h5>(CSC 645) Computer Networks</h5>
                      </li>
                      <li className="qualification__course__item">
                        <h5>(CSC 630) Computer Graphics System Design</h5>
                      </li>
                    </ul>
                  </div>
                </div>

                <div>
                  <span className="qualification__rounder">2024</span>
                  <span className="qualification__line"></span>
                </div>

                <div></div>
              </div>

              <div className="qualification__data">
                <div>
                  <h3 className="qualification__title"> Fall Semester </h3>
                  <span className="qualification__subtitle">
                    San Francisco State University
                  </span>
                  <div className="qualification__courses">
                    <ul className="qualification__course__list">
                      <li className="qualification__course__item">
                        <h5>(CSC 415) Operating System Principles</h5>
                      </li>
                      <li className="qualification__course__item">
                        <h5>(CSC 665) Artificial Intelligence</h5>
                      </li>
                      <li className="qualification__course__item">
                        <h5> (CSC 675) Introduction to Database Systems </h5>
                      </li>
                    </ul>
                  </div>
                </div>

                <div>
                  <span className="qualification__rounder">2023</span>
                  <span className="qualification__line"></span>
                </div>
                <div></div>
              </div>

              <div className="qualification__data">
                <div>
                  <h3 className="qualification__title"> Spring Semester </h3>
                  <span className="qualification__subtitle">
                    San Francisco State University
                  </span>
                  <div className="qualification__courses">
                    <ul className="qualification__course__list">
                      <li className="qualification__course__item">
                        <h5>(CSC 413) Software Development</h5>
                      </li>
                      <li className="qualification__course__item">
                        <h5>
                          (CSC 317) Introduction to Web Software Development
                        </h5>
                      </li>
                      <li className="qualification__course__item">
                        <h5>(CSC 510) Analysis of Algorithms I</h5>
                      </li>
                    </ul>
                  </div>
                </div>

                <div>
                  <span className="qualification__rounder">2023</span>
                  <span className="qualification__line"></span>
                </div>
                <div></div>
              </div>

              <div className="qualification__data">
                <div>
                  <h3 className="qualification__title"> Fall Semester</h3>
                  <span className="qualification__subtitle">
                    San Francisco State University
                  </span>
                  <div className="qualification__courses">
                    <ul className="qualification__course__list">
                      <li className="qualification__course__item">
                        <h5>(CSC 340) Programming Methodology</h5>
                      </li>
                    </ul>
                  </div>
                </div>

                <div>
                  <span className="qualification__rounder">2022</span>
                  <span className="qualification__line"></span>
                </div>
                <div></div>
              </div>

              <div className="qualification__data">
                <div>
                  <h3 className="qualification__title"> Fall Semester </h3>
                  <span className="qualification__subtitle">
                    City College of San Francisco
                  </span>
                  <div className="qualification__courses">
                    <ul className="qualification__course__list">
                      <li className="qualification__course__item">
                        <h5>(CS 270) Computer Architecture w/ Assembly</h5>
                      </li>
                    </ul>
                  </div>
                </div>

                <div>
                  <span className="qualification__rounder">2021</span>
                  <span className="qualification__line"></span>
                </div>
                <div></div>
              </div>

              <div className="qualification__data">
                <div>
                  <h3 className="qualification__title"> Spring Semester </h3>
                  <span className="qualification__subtitle">
                    City College of San Francisco
                  </span>
                  <div className="qualification__courses">
                    <ul className="qualification__course__list">
                      <li className="qualification__course__item">
                        <h5>(CS 111C) Data Structures and Algorithm: Java</h5>
                      </li>
                    </ul>
                  </div>
                </div>

                <div>
                  <span className="qualification__rounder">2021</span>
                  <span className="qualification__line"></span>
                </div>
                <div></div>
              </div>

              <div className="qualification__data">
                <div>
                  <h3 className="qualification__title"> Fall Semester </h3>
                  <span className="qualification__subtitle">
                    City College of San Francisco
                  </span>
                  <div className="qualification__courses">
                    <ul className="qualification__course__list">
                      <li className="qualification__course__item">
                        <h5>(CS 111B) Programming Fundamentals: Java</h5>
                      </li>
                    </ul>
                  </div>
                </div>

                <div>
                  <span className="qualification__rounder">2020</span>
                  <span className="qualification__line"></span>
                </div>
                <div></div>
              </div>

              <div className="qualification__data">
                <div>
                  <h3 className="qualification__title"> Spring Semester </h3>
                  <span className="qualification__subtitle">
                    City College of San Francisco
                  </span>
                  <div className="qualification__courses">
                    <ul className="qualification__course__list">
                      <li className="qualification__course__item">
                        <h5>(CSC 110A) Introduction to Programming</h5>
                      </li>
                    </ul>
                  </div>
                </div>

                <div>
                  <span className="qualification__rounder">2020</span>
                </div>
                <div></div>
              </div>

              <div className="note__container container">
                <span className="note__subtitle section__subtitle">
                  Note: Only Computer Science classes included; non-Computer
                  Science classes are omitted.{" "}
                </span>
              </div>
            </div>
          )}

          {/* Work Experience */}
          {activeTab === "work" && (
            <div className="qualification__content qualification__content-active">
              <div className="work__exp__data">
                <div>
                  <h3 className="work__exp__title">No Work Experience Yet</h3>
                  <span className="work__exp__subtitle">
                    Currently looking for opportunities to gain practical and professional
                    experience.
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Education;
